import {
  CuratedColumnSymbology,
  CUSTOM_THEME,
  DEFAULT_OPACITY,
  InterpolationTypes,
  PaintColorTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/sac_cnty_school_districts': {
    dist_type: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': {
            property: 'dist_type',
            type: PaintColorTypes.CATEGORICAL,
            stops: [
              { value: 'High', color: '#a6cee3' },
              { value: 'Elementary', color: '#1f78b4' },
              { value: 'Unified', color: '#b2df8a' },
            ],
          },
          'fill-opacity': DEFAULT_OPACITY,
        },
        display_hints: {
          scale: SymbologyScales.CATEGORICAL,
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          theme: CUSTOM_THEME,
        },
      },
    ],
  },
};

export default symbologies;
